module.exports = __webpack_public_path__ + "img/wheel-bg.55aa3f26.png";